import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CategoryView from "@/pages/CategoryView";
import ProductEditor from "@/pages/ProductEditor";
import Settings from "@/pages/Settings";
import Logs from "@/pages/Logs";

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm tracking-widest" data-testid="auth-loading">LOADING…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell><Outlet /></AppShell>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/category/:id" element={<CategoryView />} />
            <Route path="/category/:id/new" element={<ProductEditor />} />
            <Route path="/product/:pid/edit" element={<ProductEditor />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/logs" element={<Logs />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 2, fontFamily: "Poppins" } }} />
    </AuthProvider>
  );
}

export default App;
